import styles from "./styles.module.scss";
import { cn } from "@/lib/utils";
import { Button, Stack } from "@altimateai/lego";
import no_access_history_contract from "../../assets/images/no_incident_contract.svg";
import { Link } from "react-router-dom";

const NoAccessHistory = () => (
  <div className={styles.no_incidents}>
    <Stack justify="center" className="al-h-full">
      <Stack direction="column" align="center" className={cn("al-p-4", styles.container)}>
        <img src={no_access_history_contract} alt="No Access history" className={styles.img} />
        <h3 className="al-mt-3 al-mb-3 al-text-black">No History Found</h3>
        <p className="al-text-gray-500 al-text-center">
          There is no access history in the last 30 days!
        </p>
        <Link to="/datasets">
          <Button style={{ borderRadius: "5px" }}>Check Datasets</Button>
        </Link>
      </Stack>
    </Stack>
  </div>
);

export default NoAccessHistory;
